import { useEffect } from "react";
import { usePublicSettings } from "../hooks/usePublicSettings";

export function AppTitle() {
	const { appName, loaded } = usePublicSettings();
	useEffect(() => {
		if (loaded) {
			document.title = appName;
		}
	}, [appName, loaded]);
	return null;
}
